import React, { useState } from 'react';
import styled from 'styled-components';
import { Checkbox, List, Image, Segment, Dropdown } from 'semantic-ui-react';
import { Row, Col } from 'antd';
import icon from 'images/mapClustoer/sikdae_log.svg';
import thumb from 'images/mapClustoer/thumb_default.svg';
import SelectedCompleteButton from './SelectedCompleteButton';

const StyledDiv = styled.div`
  width: 30%;
  // margin-left: 24px;

  @media only screen and (max-width: 768px) {
    // height: calc(((100vh - 20px) / 2) - 1rem);
    height: calc(100vh - 20px);
    width: 100%;
    margin-left: 0;
    margin-bottom: 60px;
    overflow-y: hidden;
    //margin-bottom: 9rem;
  }
`;

const StyledMarginDiv = styled.div`
  margin-top: 1rem;
`;

const StyledList = styled(List)`
  height: calc(100% - 60px);
  overflow-y: auto;
  margin: 0 !important;

  & .header {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #212529 !important;
  }

  & .description {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    display: flex;
    align-items: center;
    color: #afb3b8 !important;
  }

  .ui.checkbox input:checked ~ .box:after,
  .ui.checkbox input:checked ~ label:after {
    opacity: 1;
    color: rgb(255 255 255);
    background: #0bb656;
    border-radius: 0.21428571rem;
  }

  .ui.checkbox .box:before,
  .ui.checkbox label:before {
    border: 2px solid #d4d4d5;
  }

  @media only screen and (min-width: 768px) {
    height: calc(100% - 300px);
    overflow-y: auto;
    margin-bottom: 40px;
  }
`;

const SideHeader = styled.div``;

const Form = styled.div`
  position: static;
  height: 52px;
  background: #ffffff;
  margin: 0;
  border-top: solid 1px #efefef;

  & .ant-row {
    position: relative;
    align-items: center;
    align-content: center;
    justify-content: space-between;
    height: 100%;
    padding: 0px 30px 0px 30px;
  }

  & .availableCount {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: #4f4f4f;
  }
`;

const SideTitle = styled.div`
  display: block;
  padding: 48px 30px 53px 30px;
  font-style: normal;
  font-weight: bold;
  font-size: 26px;
  line-height: 38px;
  letter-spacing: -0.06em;
  color: #000000;

  & img {
    padding-bottom: 16px;
  }

  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const Span = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  align-items: center;
  color: #afb3b8;

  border: 1px solid #ededf2;
  box-sizing: border-box;
  border-radius: 4px;
  margin-right: 4px;
  padding: 1px 4px 0px;
`;

const Img = styled(Image)`
  width: 64px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  border-radius: 8px;
`;

const Content = styled(List.Content)`
  width: calc(100% - 120px) !important;
`;

const Ellipsis = styled(List.Content)`
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  max-width: 566px;
  overflow: hidden;
`;

const ShadowBox = styled.div`
  height: 13px;
  width: 100%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.05) 0%, rgba(196, 196, 196, 0) 100%);
  background-blend-mode: multiply;
  position: fixed;
`;

const StyledCheckBox = styled(Checkbox)`
  margin: 0px 21px 0px 13px;
  vertical-align: middle;
  input:checked ~ label:after {
    opacity: 1;
    color: rgb(255 255 255);
    background: #0bb656;
    border-radius: 0.21428571rem;
  }

  label:before {
    border: 2px solid #d4d4d5;
  }
`;

const Stores = ({
  availableCount,
  stores,
  markers,
  onChange,
  onChangeAll,
  onComplete,
  address = [],
  onSelected,
  selectedStores = [],
  value
}) => {
  const listClick = (e, i) => {
    e.stopPropagation();
    e.preventDefault();
    // naver 미로드 시 클릭 핸들러 크래시 방지
    if (!window.naver || !window.naver.maps) return;
    window.naver.maps.Event.trigger(markers[i], 'click');
  };

  const hasStores = !!(stores && stores.length);

  const includeCheckedStores = stores.map((e) => {
    if (selectedStores.includes(e.sid)) {
      return {
        ...e,
        isSelected: true
      };
    }
    return {
      ...e,
      isSelected: false
    };
  });

  const currentSelect =
    includeCheckedStores && includeCheckedStores.length && includeCheckedStores.filter((e) => e.isSelected).length;
  const isAllChecked = currentSelect !== 0 && stores.length !== 0 && stores.length === currentSelect;

  return (
    <StyledDiv>
      <SideHeader>
        <SideTitle>
          <img alt="logo" src={icon} />
          <div className="text">
            안녕하세요, 담당자님
            {/*<br />*/}
            <Col>
              <Dropdown selection value={value} options={address} onChange={onSelected} /> 에서
            </Col>
            {/*<br />*/}
            제휴할 식당을 선택 후 제출해주세요.
          </div>
        </SideTitle>

        <Form>
          <Row>
            <Col>
              <StyledCheckBox checked={isAllChecked} onChange={onChangeAll} />
            </Col>
            <Col className="availableCount">최대 {availableCount}개 선택가능</Col>
            <Col>
              <SelectedCompleteButton onSelectedComplete={onComplete} currentSelect={currentSelect} />
            </Col>
          </Row>
        </Form>
      </SideHeader>

      <StyledList selection divided verticalAlign="middle" size="large">
        <ShadowBox />
        {hasStores &&
          includeCheckedStores.map((store, i) => {
            const color = store.isSelected ? 'rgba(221, 246, 231, 0.2)' : '#fff';
            return (
              // eslint-disable-next-line react/no-array-index-key
              <List.Item key={`${store.sid}-${i}`} style={{ backgroundColor: color, border: 'none' }}>
                <Checkbox
                  checked={store.isSelected}
                  onChange={(e, { checked }) => onChange(i, checked, store.sid)}
                  style={{
                    margin: '0px 21px 0px 13px',
                    verticalAlign: 'middle'
                  }}
                />
                <Img src={store.imageThumbnail ? store.imageThumbnail : thumb} />
                <Content onClick={(e) => listClick(e, i)}>
                  <List.Header>{store.name}</List.Header>
                  <List.Description>
                    <Ellipsis>{store.intro ? store.intro : store.name}</Ellipsis>
                  </List.Description>
                  <List.Description>
                    <Span>{store.category}</Span>
                    {store.supplyType.map((row, key) => {
                      // eslint-disable-next-line react/no-array-index-key
                      return <Span key={`supplyType-${key}`}>{row}</Span>;
                    })}
                  </List.Description>
                </Content>
              </List.Item>
            );
          })}
        {/* {status === 'PROPOSE' ? (
          <List.Item>
            <List.Content verticalAlign="middle">
              <SelectedCompleteButton onSelectedComplete={onComplete} />
            </List.Content>
          </List.Item>
        ) : null} */}
      </StyledList>
    </StyledDiv>
  );
};

export default Stores;
